import {
    Typography,
    Box,
    CircularProgress,
    Alert,
    Divider,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    Chip
} from '@mui/material';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import { useOperationsList } from '../hooks/useOperationsList';

export const OperationList: React.FC<{ projectId: string | undefined; selectedOperation: any; setSelectedOperation: (id: string) => void }> = ({ projectId, selectedOperation, setSelectedOperation }) => {

    const { operations, loading, error } = useOperationsList({ projectId });

    if (loading) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', p: 3 }}>
                <CircularProgress />
            </Box>
        );
    }

    if (error) {
        return (
            <Box sx={{ p: 2 }}>
                <Alert severity="error">{error}</Alert>
            </Box>
        );
    }

    if (operations.length === 0) {
        return (
            <Box sx={{ p: 2 }}>
                <Alert severity="info">No operations found for this project.</Alert>
            </Box>
        );
    }

    return (
        <Box
            display="flex"
            flexDirection="column"
            height="100%"
            overflow="hidden"
        >
            <List
                disablePadding
                sx={{
                    flex: 1,
                    overflowY: "auto",
                    overflowX: "hidden",
                    py: 1
                }}
            >
                {operations.map((item: any, idx: number) => (
                    <ListItem
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            pl: 2,
                            pr: 2,
                            justifyContent: "space-between",
                            gap: 1,
                            py: 1,
                            cursor: "pointer",
                            bgcolor: "transparent",
                            borderLeft: "3px solid transparent",
                            "&:hover": {
                                bgcolor: "action.hover",
                            },
                            borderBottom: theme => `1px solid ${theme.palette.divider}`,
                            ...(selectedOperation && selectedOperation.id === item.id ? {
                                borderLeft: theme => `3px solid ${theme.palette.primary.main}`,
                                bgcolor: 'action.selected'
                            } : {})
                        }}
                        onClick={() => setSelectedOperation(item)}
                    >
                        <ListItemIcon sx={{ minWidth: 18 }}>
                            <DescriptionOutlinedIcon />
                        </ListItemIcon>
                        <ListItemText>
                            <Box
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                    gap: 1,
                                }}
                            >
                                <Typography
                                    variant="body2"
                                    color={"text.primary"}
                                    sx={{
                                        fontWeight: 400,
                                    }}
                                >
                                    {item.name}
                                </Typography>
                                <Chip
                                    size="small"
                                    variant={"outlined"}
                                    label={item.frequency}
                                />
                            </Box>
                        </ListItemText>
                    </ListItem>
                ))}
            </List>
        </Box>
    );
};